<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: planType === 0 }">装车任务</div>
      <div @click="typeFun(1)" class="right" :class="{ active: planType === 1 }">卸车任务</div>
    </div>
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>供应商名称：</p>
        <el-input v-model="supplierName" size="mini" style="width: 150px" placeholder="请输入供应商名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>船舶名称：</p>
        <el-input v-model="shipIpt" size="mini" style="width: 150px" placeholder="请输入船舶名称" />
      </div>
      <div class="navContainer">
        <p>航次：</p>
        <el-input v-model="voyageIpt" size="mini" style="width: 150px" placeholder="请输入航次" />
      </div>
      <!-- <div v-if="planType===1" class="navContainer" style="width: 230px">
        <p>任务编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入任务编号"/>
      </div> -->
      <div class="navContainer" style="width: 230px">
        <p>作业港口：</p>
        <el-input v-model="terminalIpt" size="mini" style="width: 150px" placeholder="请输入港口" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>任务类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width: 150px">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <!--      <div class="navContainer" style="width: 480px">-->
      <!--        <p>{{planType?'卸车时间':'装车时间'}}：</p>-->
      <!--        <el-date-picker-->
      <!--          v-model="yearIpt"-->
      <!--          size="mini"-->
      <!--          type="datetimerang"e-->
      <!--          range-separator="至"-->
      <!--          value-format="yyyy-MM-dd HH:mm:ss"-->
      <!--          start-placeholder="开始时间"-->
      <!--          end-placeholder="结束时间"/>-->
      <!--      </div>-->
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width: 150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" v-if="planType == 1" type="primary" @click="addBtn(1)">卸车 </el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <div class="tableContainerNav">
          <span @click="downLoad">下载模板</span>
          <span style="cursor: pointer">
            <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :auto-upload="true" :show-file-list="false" :data="uploadData" :on-success="planOnSuccess" :before-upload="beforeUpload">
              <i class="el-icon-upload el-icon--right">批量导入</i>
            </el-upload>
          </span>
        </div>
        <el-table v-loading="tableLoad" :data="TableDatas" style="width: 100%" border stripe :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="supplierName" label="供应商名称" align="center" />
          <el-table-column prop="shipName" label="船舶名称" align="center" />
          <el-table-column prop="voyageNumber" label="航次" align="center" />
          <el-table-column prop="portName" label="作业港口" align="center" />
          <el-table-column label="任务类型" align="center">
            <div slot-scope="scope">{{ taskTypeFormat(scope.row.taskType) }}</div>
          </el-table-column>
          <el-table-column prop="arrivalDate" label="预进港时间" align="center" />
          <el-table-column prop="taskDate" :label="planType ? '卸车时间' : '预计装车时间'" align="center" />
          <el-table-column prop="actualDate" label="实际作业时间" :formatter="getDate" align="center" />
          <el-table-column prop="loadingNum" label="预作业数量" align="center" width="80px" />
          <el-table-column prop="leftoverNum" label="实际作业数量" align="center" width="80px" />
          <el-table-column prop="status" label="状态" align="center" width="45">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="scope">
              <div style="align-items: center">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情 </el-button>
                <!-- 正常作业 装车 -->
                <el-button size="mini" v-if="(scope.row.status == 0 || scope.row.status == 1) && scope.row.taskType == 0 && !planType" type="primary" @click="addBtn(0, scope.row)">装车 </el-button>
                <!-- 转船 装车 -->
                <el-button size="mini" v-if="(scope.row.status == 0 || scope.row.status == 1) && scope.row.taskType == 2 && !planType" type="primary" @click="addBtn(4, scope.row)">装车 </el-button>
                <!-- 过驳 -->
                <el-button size="mini" v-if="(scope.row.status == 0 || scope.row.status == 1) && scope.row.taskType == 1" type="primary" @click="addBtn(2, scope.row)">过驳 </el-button>
                <!-- 转船 卸车 -->
                <el-button size="mini" v-if="scope.row.status == 1 && scope.row.taskType == 1" type="primary" class="yellow-bg" @click="refuteFinish(scope.row)">过驳完成 </el-button>
                <el-button size="mini" v-if="(scope.row.status == 0 || scope.row.status == 1) && scope.row.taskType == 2 && planType" type="primary" @click="addBtn(3, scope.row)">卸车 </el-button>
                <!-- <el-button size="mini" v-if="(scope.row.status == 1 || scope.row.status == 0) && !planType && scope.row.taskType != 1 && scope.row.loadingNum == 0" type="primary" class="yellow-bg" @click="loadingFinish(scope.row.id)"> 装车完成 </el-button> -->

                <el-button size="mini" v-if="(scope.row.status == 1 && !planType && scope.row.taskType != 1) || (scope.row.status == 0 && scope.row.loadingNum == 0)" type="primary" class="yellow-bg" @click="loadingFinish(scope.row.id)"> 装车完成 </el-button>

                <el-button size="mini" v-if="scope.row.status == 1 && planType && scope.row.taskType != 1" type="primary" class="yellow-bg" @click="unloadFinish(scope.row.id)">卸车完成 </el-button>
                <!--                <el-button size='mini' v-if='(scope.row.status==0||scope.row.status==1)'
                           type='primary' @click='allotBtn(scope.row)'>分配委托车
                </el-button>-->
                <el-button size="mini" v-if="scope.row.status == 0 && planType === 0" type="danger" @click="deleteClick(scope.row.id)">删除 </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog :title="detailTitle" :visible.sync="detailDialogVisible" width="800px" center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">供应商名称：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">船舶名称：</span>
                <span>{{ detailData.shipName }}</span>
              </div>
              <div>
                <span class="span1">航次：</span>
                <span>{{ detailData.voyageNumber }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">任务类型：</span>
                <span>{{ getType(detailData.taskType) }}</span>
              </div>
              <div>
                <span class="span1">操作类型：</span>
                <span>{{ operationFormat(detailData.operationType) }}</span>
              </div>
            </div>
            <div v-if="detailData.taskType != 0" class="baseInfoContentItem">
              <span class="span1">转入船名：</span>
              <span>{{ detailData.exchangeShipName }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">预计装车数量：</span>
                <span>{{ detailData.loadingNum }}</span>
              </div>
              <div>
                <span class="span1">实际装车数量：</span>
                <span>{{ detailData.leftoverNum }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">预计进港时间：</span>
              <span>{{ detailData.arrivalDate }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">预计作业时间：</span>
              <span>{{ detailData.taskDate }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">实际作业时间：</span>
              <span>{{ detailData.actualDate }}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>委托车信息</span>
          </div>
          <div class="operationTable">
            <div v-model="carList" class="nav">
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">批次号：</p>
                <el-input v-model="carList.batchNumber" size="mini" style="width: 135px" placeholder="输入批次号" />
              </div>
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">运单号：</p>
                <el-input v-model="carList.waybillNo" size="mini" style="width: 135px" placeholder="输入运单号" />
              </div>
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">车架号：</p>
                <el-input
                  v-model="carList.frameNumber"
                  size="mini"
                  style="width: 135px"
                  placeholder="输入车架号"
                  @paste.native.capture.prevent="
                    value => {
                      return searchCopyFormat(value);
                    }
                  " />
              </div>
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">品牌：</p>
                <el-input v-model="carList.brand" size="mini" style="width: 135px" placeholder="输入品牌" />
              </div>
              <!--              <div class="navContainer" style="width: 160px">-->
              <!--                <p style="font-size: 8px">所在船舱：</p>-->
              <!--                <el-input v-model="carList.shipCabinName" size="mini" style="width:135px" placeholder="输入船舱"/>-->
              <!--              </div>-->
              <!--              <div class="navContainer" style="width: 160px">-->
              <!--                <p style="font-size: 8px">起始港：</p>-->
              <!--                <el-input v-model="carList.startPortName" size="mini" style="width:135px" placeholder="输入起始港"/>-->
              <!--              </div>-->
              <!--              <div class="navContainer" style="width: 160px">-->
              <!--                <p style="font-size: 8px">交车港：</p>-->
              <!--                <el-input v-model="carList.deliveryPortName" size="mini" style="width:135px" placeholder="输入交车港"/>-->
              <!--              </div>-->
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">是否质损：</p>
                <el-select v-model="carList.isMassLoss" style="width: 135px" size="mini" filterable clearable placeholder="请选择">
                  <el-option v-for="item in options" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="navContainer" style="width: 160px">
                <p style="font-size: 8px">状态：</p>
                <el-select v-model="carList.state" style="width: 125px" size="mini" filterable clearable placeholder="请选择">
                  <el-option v-for="item in optionsState" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="navBtn">
                <el-button size="small" class="searchBtn" @click="carpageList">查询</el-button>
                <el-button size="small" class="resetBtn" @click="resetCar">重置</el-button>
                <el-button size="small" type="primary" @click="exportClick">导出</el-button>
                <el-button size="small" type="warning" :disabled="selectionCar.length == 0 && selectionCar.length <= 0" @click="open" v-if="planType == 0">回退 </el-button>
              </div>
            </div>
            <div>
              <span style="float: right" v-if="planType == 0">回退数据：{{ selectionCar.length }}条</span>
            </div>
            <el-table :data="operationData" ref="entrustCar" key="entrustCar" row-key="id" style="width: 100%" @selection-change="handleSelectionChangeCar" v-loading="htLoading" border>
              <el-table-column type="selection" reserve-selection width="30" align="center" v-if="planType == 0"></el-table-column>
              <el-table-column prop="batchNumber" label="批次号" width="100" align="center" />
              <el-table-column prop="waybillNo" label="运单号" width="130" align="center" />
              <el-table-column prop="frameNumber" label="车架号" width="150" align="center" />
              <el-table-column prop="brand" label="品牌" align="center" />
              <el-table-column prop="model" label="型号" min-width="100" show-overflow-tooltip align="center" />
              <el-table-column prop="color" label="颜色" align="center" />
              <el-table-column prop="fileName" label="附件信息" align="center" />
              <el-table-column label="状态" align="center">
                <div slot-scope="scope">{{ getState1(scope.row.state) }}</div>
              </el-table-column>
            </el-table>
            <div class="paginationContainer" style="margin: 10px 0 0 0">
              <span>共{{ detail.total }}条</span>
              <el-pagination background small :page-sizes="[10, 50, 300]" layout="sizes,prev, pager, next,jumper" :total="detail.total" :current-page.sync="detail.page" @size-change="detailSizeChange" @current-change="detailChange" @prev-click="detailChange" @next-click="detailChange" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="850px" @close="dialogClose" center :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="teamData" label-width="120px" :rules="rules" ref="ruleForm">
          <div class="transport">
            <div-border label="基础信息" style="padding: 20px 0">
              <el-form-item v-if="dialogTitle == '卸车' && unloadType" label="卸车船舶：" prop="entrust">
                <el-select v-model="teamData.entrust" size="mini" filterable style="width: 85%" placeholder="请选择船舶" value-key="id" @change="shipChange">
                  <el-option v-for="item in entrustOption" :key="item.id" :label="item.name" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="dialogTitle == '卸车' && unloadType" label="卸车港口：" prop="shippers">
                <el-select v-model="teamData.shippers" filterable size="mini" style="width: 85%" value-key="id" placeholder="请选择港口">
                  <el-option v-for="item in shippersOption" :key="item.id" :label="item.supplier_name" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="作业时间：" prop="loadDate">
                <el-date-picker type="datetime" v-model="teamData.loadDate" style="width: 85%" size="mini" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择作业时间" />
              </el-form-item>
              <el-form-item v-if="dialogTitle == '卸车' && unloadType" label="是否转船：" prop="transship">
                <el-radio-group v-model="teamData.transship">
                  <el-radio label="0">否</el-radio>
                  <el-radio label="2">是</el-radio>
                </el-radio-group>
              </el-form-item>
            </div-border>
            <div-border label="作业车辆：" style="padding: 10px" v-loading="loadingWorkVehicles">
              <div class="nav">
                <div class="navContainer" style="flex: 4; justify-content: center">
                  <p style="width: 60px; display: inline-block; text-align: right">批次号：</p>
                  <el-input v-model="condition.batchNumber" size="mini" style="width: calc(100% - 70px)" onkeyup="this.value=this.value.replace(/\s/g,',')" @change="judgeLen($event, 'batchNumber')" placeholder="请输入批次号" />
                </div>
                <div class="navContainer" style="flex: 4; justify-content: center">
                  <p style="width: 60px; display: inline-block; text-align: right">运单号：</p>
                  <el-input v-model="condition.waybillNo" size="mini" style="width: calc(100% - 70px)" onkeyup="this.value=this.value.replace(/\s/g,',')" @change="judgeLen($event, 'waybillNo')" placeholder="请输入运单号" />
                </div>
                <div class="navContainer" v-if="unloadType" style="flex: 4; justify-content: center">
                  <p style="width: 60px; display: inline-block; text-align: right">车架号：</p>
                  <el-input v-model="condition.frameNumber" size="mini" style="width: calc(100% - 70px)" onkeyup="this.value=this.value.replace(/\s/g,',')" @change="judgeLen($event, 'frameNumber')" placeholder="请输入车架号" />
                </div>
                <div class="navBtn" style="display: flex; width: 100%; justify-content: flex-end">
                  <el-upload v-if="dialogTitle === '过驳'" ref="upload" class="upload-demo mr10" :disabled="importDis || shippingId === ''" :action="importUrl" :auto-upload="true" :show-file-list="false" :data="importData" :http-request="importUploadHttp" :on-success="importPlanOnSuccess" :before-upload="importBeforeUpload">
                    <el-button size="mini" type="primary" :disabled="importDis || shippingId === ''"> 导入 </el-button>
                  </el-upload>
                  <el-button size="small" class="searchBtn" @click="carWorkSearchBtn">查询 </el-button>
                  <el-button size="small" class="resetBtn" @click="carResetBtn">重置</el-button>
                </div>
              </div>
              <!--              <span v-if='dialogTitle === "过驳"'
                                  style='display:block;width100%;text-align:right;padding:0 5px 5px'>已选择{{ importReturnData.length
                              }}辆</span>-->
              <span style="display:block;width100%;text-align:right;padding:0 5px 5px">已选择{{ carLength }}辆</span>
              <el-table v-loading="carTableLoad" v-if="planType == 1 && dialogTitle == '卸车'" key="table1" :data="teamData.table" style="width: 100%" ref="table1" row-key="id" border @selection-change="handleSelectionChange">
                <el-table-column type="selection" reserve-selection width="30" />
                <el-table-column prop="batchNumber" label="批次号" width="120px" align="center" />
                <el-table-column prop="waybillNo" label="运单号" width="150px" align="center" />
                <el-table-column prop="frameNumber" label="车架号" width="150px" align="center" />
                <el-table-column prop="brand" label="品牌" width="80px" align="center" />
                <el-table-column prop="model" label="型号" show-overflow-tooltip width="100" align="center" />
                <el-table-column prop="weight" label="重量" width="50px" align="center" />
                <el-table-column prop="fileName" label="附件" align="center" />
                <el-table-column v-if="dialogTitle !== '手动卸车'" prop="deliveryPortName" label="交车港口" align="center" />
              </el-table>
              <el-table v-loading="carTableLoad" v-if="dialogTitle == '过驳' || (dialogTitle == '装车' && loadingType)" key="table3" ref="table2" :data="teamData.table" style="width: 100%" row-key="id" border @selection-change="handleSelectionChange" :resever-selection="true">
                <el-table-column type="selection" reserve-selection width="30" />
                <el-table-column prop="batchNumber" label="批次号" width="120px" align="center" />
                <el-table-column prop="waybillNo" label="运单号" width="150px" align="center" />
                <el-table-column prop="frameNumber" label="车架号" width="150px" align="center" />
                <el-table-column prop="brand" label="品牌" width="80px" align="center" />
                <el-table-column prop="model" label="型号" show-overflow-tooltip width="100" align="center" />
                <el-table-column prop="weight" label="重量" width="50px" align="center" />
                <el-table-column prop="fileName" label="附件" align="center" />
                <el-table-column v-if="dialogTitle !== '手动卸车'" prop="deliveryPortName" label="交车港口" align="center" />
              </el-table>
              <el-table v-if="planType == 0 && dialogTitle == '装车' && !loadingType" :data="teamData.table" key="table2" ref="table3" v-loading="carTableLoad" style="width: 100%" border stripe @expand-change="expandChange" :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '30px', background: '#E8E8E8' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '30px' }">
                <el-table-column type="expand" width="30">
                  <template slot-scope="scopeOut">
                    <div style="width: 95%; margin-left: auto" v-loading="scopeOut.row.loading">
                      <el-table :data="scopeOut.row.children" border max-height="300" style="width: 100%" :ref="scopeOut.row.batch_number + scopeOut.row.waybill_no" @selection-change="handleCurrentChange($event, scopeOut.row.batch_number + scopeOut.row.waybill_no)" :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '30px', background: '#E8E8E8' }" :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '30px' }">
                        <el-table-column type="selection" align="center" width="50px" />
                        <el-table-column prop="frame_number" label="车架号" min-width="130" align="center">
                          <template slot-scope="scope">
                            <span v-if="scope.row.state == 1" class="require">{{ scope.row.frame_number }}</span>
                            <span v-else>{{ scope.row.frame_number }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="brand_name" label="品牌" min-width="100" align="center" />
                        <el-table-column prop="model_name" label="型号" show-overflow-tooltip width="100" align="center" />
                        <el-table-column prop="weight" label="重量" align="center" />
                        <el-table-column prop="departure_port" label="交车港口" align="center" />
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="batch_number" label="批次号" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.state == 1" class="require">{{ scope.row.batch_number }}</span>
                    <span v-else>{{ scope.row.batch_number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="waybill_no" label="运单号" align="center" />
                <el-table-column prop="count_car" label="数量" align="center" />
              </el-table>
              <div class="paginationContainer" style="margin-top: 10px">
                <span>共{{ condition.total }}条</span>
                <el-pagination background :page-size="10" :page-sizes="[10, 20, 40]" layout="sizes, prev, pager, next, jumper" :current-page.sync="condition.page" :total="condition.total" @size-change="conditionSizeChange" @current-change="conditionCurrentChange" @prev-click="conditionCurrentChange" @next-click="conditionCurrentChange" />
              </div>
            </div-border>
          </div>
        </el-form>
        <div class="btnContainer">
          <el-button class="searchBtn" :loading="imgIsUpload" @click="saveClick" size="small">确定 </el-button>
          <el-button class="resetBtn" @click="dialogClose" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogAllotTitle" :visible.sync="allotDialogVisible" center :before-close="dialogAllotClose" :close-on-click-modal="false" class="allotDialog">
      <div class="nav">
        <div class="navContainer">
          <p style="width: 60px; display: inline-block; text-align: right">运单号：</p>
          <el-input v-model="allotForm.waybillNo" size="mini" style="width: 120px" placeholder="请输入运单号" />
        </div>
        <div class="navContainer">
          <p style="width: 60px; display: inline-block; text-align: right">批次号：</p>
          <el-input v-model="allotForm.batchNumber" size="mini" style="width: 120px" placeholder="请输入批次号" />
        </div>
        <div class="navContainer" style="width: 160px">
          <p style="font-size: 8px">车架号：</p>
          <el-input
            v-model="carList.frameNumber"
            size="mini"
            style="width: 135px"
            placeholder="输入车架号"
            @paste.native.capture.prevent="
              value => {
                return searchCopyFormat(value);
              }
            " />
        </div>
        <div class="navBtn" style="display: flex; justify-content: flex-end">
          <el-button size="small" class="searchBtn" @click="allotSearchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="allotResetBtn">重置</el-button>
          <el-button size="small" class="submit" @click="submit">确认</el-button>
        </div>
      </div>
      <div class="tableContent">
        <el-table ref="allotTable" :data="allotData.table" :row-key="getRowKey" v-loading="allotTableLoad" style="width: 100%; height: 400px; overflow-y: auto" border :header-cell-style="headerCellStyle" @selection-change="allotDataSelectionChange">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column property="waybillNo" align="center" label="运单号" width="150"></el-table-column>
          <el-table-column property="batchNumber" align="center" label="批次号" width="167"></el-table-column>
          <el-table-column property="frameNumber" align="center" label="车架号" width="150"></el-table-column>
          <el-table-column property="brandName" align="center" label="品牌" width="150"></el-table-column>
          <el-table-column property="portName" align="center" label="当前所在港口" width="150"></el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer" style="margin-top: 10px">
        <span>共{{ allotDataTotal }}条</span>
        <el-pagination background :page-sizes="[800, 1600]" layout="sizes,prev, pager, next,jumper" :current-page.sync="allotForm.page" :total="allotDataTotal" @size-change="allotFormSizeChange" @current-change="allotFormCurrentChange" @prev-click="allotFormCurrentChange" @next-click="allotFormCurrentChange" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { dockInfoCvWaterPageList, dockInfoCvWaterDetail, batchLoading, loadingFinish, getUnloadList, dockInfoShipScanUnloading, batchTurnDischarge, loadingPageList, loadingChildPageList, shipDeployPublicSelectPort, refutePageList, pagePortTaskList, batchTurnRefuteLoading, refuteFinish, batchTurnLoading, unloadFinish, appointTurnLoading, dockInfoDetailPageList, selectUnloadShip, vehicleErrorFallback, selectUnAssignedVehicle, assignVehicle, deleteShipPort } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';
  import { formatDateTime } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { updatePrice } from '@/service/financial';
  import axios from 'axios';
  import { aria as res } from 'echarts/lib/lang';
  import { submitAudit } from '@/service/getData';

  export default {
    components: { divBorder },
    data() {
      return {
        loadingWorkVehicles: false,
        importLoading: false,
        htLoading: false,
        options: [
          {
            value: '0',
            lable: '否',
          },
          {
            value: '1',
            lable: '是',
          },
        ],
        optionsState: [
          {
            value: '0',
            lable: '待装车',
          },
          {
            value: '1',
            lable: '已装船',
          },
          {
            value: '2',
            lable: '已交车',
          },
          {
            value: '-1',
            lable: '已取消',
          },
        ],
        carList: {
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        },
        shipIpt: '',
        voyageIpt: '',
        numIpt: '',
        typeIpt: '',
        terminalIpt: '',
        planType: 0,
        yearIpt: '',
        stateIpt: '',
        supplierName: '',
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待执行 ',
          },
          {
            value: 1,
            label: '执行中',
          },
          {
            value: 2,
            label: '已完成',
          },
        ],
        typeOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '过驳',
          },
          {
            value: 2,
            label: '转船',
          },
        ],
        //分配委托车
        dialogAllotTitle: '分配委托车',
        allotDialogVisible: false,
        allotTableLoad: false,
        allotLoad: false,
        shipDeployPortId: '', // 行数据id
        portFocusId: '',
        shipAssignedVehicles: [],
        allotData: {
          table: [],
          selection: [],
        },
        allotDataTotal: 0,
        allotForm: {
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          portId: '',
          page: 1,
          rows: 1000,
          size: 1000,
        },
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '90px',
          background: '#E8E8E8',
        },

        tableLoad: false,
        TableDatas: [],
        page: 1,
        size: 10,
        total: 0,
        // 批量导入 -- 数据
        uploadUrl: '',
        uploadData: {
          file: '',
        },
        // 详情
        detailDialogVisible: false,
        detailData: {},
        detailTitle: '',
        operationData: [],
        detail: {
          page: 1,
          total: 0,
          size: 10,
        },

        // 装车/卸车
        dialogTitle: '',
        shippersOption: [],
        entrustOption: [],
        unloadType: false,
        loadingType: false,
        dialogVisible: false,
        imgIsUpload: false,
        teamData: {
          shippers: '',
          entrust: '',
          place: '',
          supplier: '',
          loadDate: '',
          table: [],
          selection: [],
        },
        selectionCar: [],
        allotDataSelection: [], // 委托车选择
        rules: {
          transship: [
            {
              required: true,
              message: '请选择是否转船',
              trigger: 'change',
            },
          ],
          loadDate: [
            {
              required: true,
              message: '请选择时间',
              trigger: 'change',
            },
          ],
          entrust: [
            {
              required: true,
              message: '请选择船舶',
              trigger: 'change',
            },
          ],
          shippers: [
            {
              required: true,
              message: '请选择港口',
              trigger: 'change',
            },
          ],
        },
        condition: {
          // 装车车辆 查询条件
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          page: 1,
          size: 10,
          total: 0,
        },
        carTableLoad: false, // 装车车辆 加载中
        selectData: [], //装车车辆 —— 批次号 选中数据
        carLength: 0,
        shippingId: '',
        importDis: false,
        importUrl: '',
        importData: {
          mFile: '',
        },
        importReturnData: [],
      };
    },
    computed: {
      getType() {
        return function (state) {
          switch (state) {
            case 0:
              return '正常作业';
            case 1:
              return '过驳';
            case 2:
              return '转船';
            case 3:
              return '入库';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case -1:
              return '已取消';
            case 0:
              return '待执行';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
      getState1() {
        return function (state) {
          switch (state) {
            case -1:
              return '已取消';
            case 0:
              return this.planType ? '待卸船' : '待装车';
            case 1:
              return this.planType ? '已卸船' : '已装船';
            case 2:
              return '已交车';
          }
        };
      },
      taskTypeFormat() {
        return function (state) {
          switch (state) {
            case 0:
              return '正常作业';
            case 1:
              return '过驳';
            case 2:
              return '转船';
          }
        };
      },
      operationFormat() {
        return function (state) {
          switch (state) {
            case 0:
              return '装车';
            case 1:
              return '卸车';
          }
        };
      },
    },
    mounted() {
      //this._dockInfoCvWaterPageList();
      this.uploadUrl = getImportUrl('/transportScanOperation/importExcelxlAddShipIn');
      this.importUrl = getImportUrl('/vehicleDeployCar/portBatchQueryId');
    },
    methods: {
      deleteClick(id) {
        this.$confirm('确定要删除当前任务吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteShipPort({id});
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.page = 1;
            await this._dockInfoCvWaterPageList();
          })
          .catch(() => {});
      },
      open() {
        this.$confirm('是否回退' + this.selectionCar.length + '条数据！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            //调用回退接口
            this.htLoading = true;
            let obj = {
              type: 1,
              deployPortId: this.detail.id,
              carIdList: this.selectionCar,
            };
            const res = await vehicleErrorFallback(obj);
            if (res.status !== 0) {
              this.$message.error(res.message);
              this.htLoading = false;
            }
            if (res.status == 0) {
              this.$message.success(res.message);
              if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
              this.selectionCar = [];
              this._carPageList();
              this.htLoading = false;
              this._dockInfoCvWaterPageList();
            }
          })
          .catch(() => {
            if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
            this.selectionCar = [];
          });
      },
      async carpageList() {
        //委托车信息查询
        let data = {
          deployPortId: this.detail.id,
          batchNumber: this.carList.batchNumber,
          waybillNo: this.carList.waybillNo,
          frameNumber: this.carList.frameNumber,
          brand: this.carList.brand,
          shipCabinName: this.carList.shipCabinName,
          startPortName: this.carList.startPortName,
          deliveryPortName: this.carList.deliveryPortName,
          isMassLoss: this.carList.isMassLoss,
          state: this.carList.state,
        };
        const res = await dockInfoDetailPageList(data);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detail.total = res.data.total;
        this.operationData = res.data.records;
      },
      exportClick() {
        //导出
        debugger;
        let token = getSessionStore('token');
        let url = baseUrl + '/platform/vehicleDeployCar/carExport';
        // url += '?supplierName='+this.teamIpt;
        url += '?deployPortId=' + this.detail.id + '&batchNumber=' + this.carList.batchNumber;
        url += '&waybillNo=' + this.carList.waybillNo + '&frameNumber=' + this.carList.frameNumber;
        url += '&brand=' + this.carList.brand + '&shipCabinName=' + this.carList.shipCabinName;
        url += '&startPortName=' + this.carList.startPortName + '&deliveryPortName=' + this.carList.deliveryPortName;
        url += '&isMassLoss=' + this.carList.isMassLoss + '&state=' + this.carList.state;
        url += '&access_token=' + token;
        window.location.href = url;
      },
      resetCar() {
        this.carList = {
          basicId: '',
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          shipCabinName: '',
          startPortName: '',
          deliveryPortName: '',
          isMassLoss: '',
          state: '',
        };
      },
      // 分页查询
      async _dockInfoCvWaterPageList() {
        this.tableLoad = true;
        const res = await dockInfoCvWaterPageList({
          shipName: this.shipIpt,
          voyageNumber: this.voyageIpt,
          taskNumber: this.numIpt,
          taskType: this.typeIpt,
          operationType: this.planType,
          status: this.stateIpt,
          supplierName: this.supplierName,
          portName: this.terminalIpt,
          startTime: this.yearIpt[0] ? this.yearIpt[0] : '',
          endTime: this.yearIpt[1] ? this.yearIpt[1] : '',
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 装车/卸车 -- 切换
      typeFun(val) {
        this.resetBtn();
        this.planType = val;
        if (val == 0) {
          this.uploadUrl = getImportUrl('/transportScanOperation/importExcelxlAddShipIn');
        } else {
          this.uploadUrl = getImport('/platform/transportScanOperation/importExcelxlAddShipOut');
        }
        // this._dockInfoCvWaterPageList();
      },
      // 重置
      resetBtn() {
        this.supplierName = '';
        this.shipIpt = '';
        this.voyageIpt = '';
        this.numIpt = '';
        this.yearIpt = '';
        this.terminalIpt = '';
        this.typeIpt = '';
        this.stateIpt = '';
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._dockInfoCvWaterPageList();
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._dockInfoCvWaterPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._dockInfoCvWaterPageList();
      },
      // 模板下载
      downLoad() {
        if (this.planType == 0) {
          window.location.href = '/file/批量装船模板.xlsx';
        } else {
          window.location.href = '/file/批量卸船模板.xlsx';
        }
      },
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            await this._dockInfoCvWaterPageList();
          },
        });
        // this._dockInfoCvWaterPageList();
      },
      beforeUpload(file) {
        // console.log(file);
        if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },

      // 详情
      async detailClick(row) {
        this.resetCar();
        if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
        this.selectionCar = [];
        this.detail.page = 1;
        this.detail.id = row.id;
        this.detail.taskType = row.taskType;
        this.detailTitle = this.planType ? '卸车详情' : '装车详情';
        this.detailDialogVisible = true;
        const res = await dockInfoCvWaterDetail(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this._carPageList();
      },
      // 详情 —— 分页查询
      async _carPageList() {
        let obj = {
          deployPortId: this.detail.id,
          batchNumber: this.carList.batchNumber,
          waybillNo: this.carList.waybillNo,
          frameNumber: this.carList.frameNumber,
          brand: this.carList.brand,
          shipCabinName: this.carList.shipCabinName,
          startPortName: this.carList.startPortName,
          deliveryPortName: this.carList.deliveryPortName,
          isMassLoss: this.carList.isMassLoss,
          state: this.carList.state,
          rows: this.detail.size,
          page: this.detail.page,
        };
        if (this.planType == 0) {
          obj.deployPortId = this.detail.id;
        }
        if (this.planType == 1) {
          obj.dischargeId = this.detail.id;
        }
        const res = await dockInfoDetailPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        if (this.detail.taskType == 2 && this.planType == 1) {
          if (res.data.records && res.data.records.length > 0) {
            res.data.records.forEach(item => {
              item.state = parseInt(item.state) - 1;
            });
          }
        }
        this.operationData = res.data.records;
        this.detail.total = res.data.total;
      },
      // 详情 —— 分页大小改变
      detailSizeChange(size) {
        // 每页条数
        this.detail.size = size;
        this._carPageList();
      },
      // 详情 —— 当前页改变
      detailChange(page) {
        // 翻页
        this.detail.page = page;
        this._carPageList();
      },

      // 获取实际作业数量
      // getNumber(row) {
      //   if((row.loadingNum||row.loadingNum==0)&&(row.leftoverNum||row.leftoverNum==0))
      //   return (row.loadingNum - row.leftoverNum);
      //   else return ''
      // },
      // 获取实际作业时间
      getDate(row) {
        if (row.status != 0 && row.actualDate) {
          return row.actualDate;
        } else {
          return '';
        }
      },
      // 装车完成
      loadingFinish(id) {
        this.$confirm('当前数据是否装车完成？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await loadingFinish(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._dockInfoCvWaterPageList();
          })
          .catch(() => {});
      },
      // 卸车完成
      unloadFinish(id) {
        this.$confirm('当前数据是否卸车完成？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await unloadFinish(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._dockInfoCvWaterPageList();
          })
          .catch(() => {});
      },

      //分配委托车
      allotBtn(row) {
        this.allotDialogVisible = true;
        this.allotForm.portId = row.portId;
        this.shipDeployPortId = row.id;
        this._SearchBtn();
      },
      //分配委托车查询
      async _SearchBtn() {
        this.allotTableLoad = true;
        let obj = {
          batchNumber: this.allotForm.batchNumber,
          waybillNo: this.allotForm.waybillNo,
          frameNumber: this.carList.frameNumber,
          portId: this.allotForm.portId,
          page: 1,
          rows: 1000,
        };
        const res = await selectUnAssignedVehicle(obj);
        this.allotTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.allotData.table = res.data.records;
        this.allotDataTotal = res.data.total;
      },
      //查询
      allotSearchBtn() {
        this._SearchBtn();
      },
      //重置
      allotResetBtn() {
        this.allotForm.waybillNo = '';
        this.allotForm.batchNumber = '';
        this.carList.frameNumber = '';
      },
      //确认
      async submit() {
        const shipAssignedVehicles = this.allotDataSelection.map(item => {
          return {
            shipDeployPortId: this.shipDeployPortId,
            portFocusId: item.id,
            frameNumber: item.frameNumber,
          };
        });
        this.$confirm('是否分配委托车？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const { status, message } = await assignVehicle(shipAssignedVehicles);
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          await this._SearchBtn();
        });
      },
      //关闭对话框
      dialogAllotClose() {
        this.allotResetBtn();
        this.allotDialogVisible = false;
        if (this.$refs.allotTable) this.$refs.allotTable.clearSelection();
      },
      getRowKey(row) {
        return row.id; // 设置行的唯一标识
      },
      allotFormSizeChange(row) {
        this.allotForm.rows = row;
        this._SearchBtn();
      },
      allotFormCurrentChange(page) {
        this.allotForm.page = page;
        this._SearchBtn();
      },
      /**
       * 装车/卸车
       */
      // 打开弹窗
      async addBtn(val, row) {
        this.teamData = {
          id: '',
          place: '',
          port: '',
          supplier: '',
          loadDate: '',
          shippers: '',
          entrust: '',
          type: '',
          table: [],
          selection: [],
        };
        this.selectData = [];
        this.teamData.selection = [];
        this.unloadType = false;
        this.loadingType = false;
        this.condition.page = 1;
        this.condition.total = 0;
        // 正常作业时装车
        if (val == 0) {
          this.dialogTitle = '装车';
          this.teamData.id = row.id;
          this.teamData.place = row.portAreaId;
          this.teamData.port = row.portId;
          this.teamData.supplier = row.supplierId;
          this.carSearchBtn();
        }
        // 手动卸车
        if (val == 1) {
          this.unloadType = true;
          this.dialogTitle = '卸车';
          let res = await shipDeployPublicSelectPort();
          if (res.status !== 0) return this.$message.error(res.message);
          this.shippersOption = res.data;
          let res1 = await selectUnloadShip();
          if (res1.status !== 0) return this.$message.error(res1.message);
          this.entrustOption = res1.data.map(item => {
            return {
              id: item.id,
              name: item.name,
            };
          });
        }
        // 过驳
        if (val == 2) {
          this.teamData.type = 1;
          if (this.planType == 0) {
            this.teamData.id = row.exchangeDeployId;
          } else {
            this.teamData.id = row.id;
          }
          this.dialogTitle = '过驳';
          this._refutePageList();
        }
        // 转船时卸车
        if (val == 3) {
          this.teamData.type = 2;
          this.teamData.id = row.id;
          this.dialogTitle = '卸车';
          this._refutePageList();
        }
        // 转船时装车
        if (val == 4) {
          this.loadingType = true;
          this.teamData.type = 2;
          this.teamData.id = row.id;
          this.dialogTitle = '装车';
          this._appointTurnLoading();
        }
        this.dialogVisible = true;
      },
      // 装车车辆 一级 —— 查询
      async carSearchBtn() {
        let obj = {
          type: 1,
          batchNumber: this.condition.batchNumber,
          waybillNo: this.condition.waybillNo,
          departurePlaceId: this.teamData.place,
          departurePortId: this.teamData.port,
          supplierId: this.teamData.supplier,
          page: this.condition.page,
          rows: this.condition.size,
        };
        this.carTableLoad = true;
        const res = await loadingPageList(obj);
        this.carTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        // 给数据加上 index和children
        if (res.data.records.length > 0) {
          res.data.records.forEach((item, index) => {
            item.index = index;
            item.loading = true;
            item.children = [];
          });
        }
        this.teamData.table = res.data.records;
        this.condition.total = res.data.total;
      },
      // 装车车辆 二级 —— 查询
      async carSearchChildBtn(row) {
        let obj = {
          type: 1,
          departurePlaceId: this.teamData.place,
          departurePortId: this.teamData.port,
          supplierId: this.teamData.supplier,
          batchNumber: row.batch_number,
          waybillNo: row.waybill_no,
        };
        const res = await loadingChildPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table[row.index].children = res.data;
      },
      // 切换每页数据条数
      conditionSizeChange(sizes) {
        this.condition.size = sizes;
        // 正常作业 装车
        if (this.dialogTitle == '装车' && !this.loadingType) {
          this.carSearchBtn();
        }
        // 转船 装车
        if (this.dialogTitle == '装车' && this.loadingType) {
          this._appointTurnLoading();
        }
        // 手动卸车
        if (this.dialogTitle == '卸车' && this.unloadType) {
          this._getUnloadList();
        }
        // 转船 卸车
        if (this.dialogTitle == '卸车' && !this.unloadType) {
          this._refutePageList();
        }
        if (this.dialogTitle == '过驳') {
          this._refutePageList();
        }
      },
      // 装车车辆 —— 换页
      conditionCurrentChange(page) {
        this.condition.page = page;
        // 正常作业 装车
        if (this.dialogTitle == '装车' && !this.loadingType) {
          this.carSearchBtn();
        }
        // 转船 装车
        if (this.dialogTitle == '装车' && this.loadingType) {
          this._appointTurnLoading();
        }
        // 手动卸车
        if (this.dialogTitle == '卸车' && this.unloadType) {
          this._getUnloadList();
        }
        // 转船 卸车
        if (this.dialogTitle == '卸车' && !this.unloadType) {
          this._refutePageList();
        }
        if (this.dialogTitle == '过驳') {
          this._refutePageList();
        }
      },
      // 车辆查询
      carWorkSearchBtn() {
        // 正常作业 装车
        if (this.dialogTitle == '装车' && !this.loadingType) {
          this.carSearchBtn();
        }
        // 转船 装车
        if (this.dialogTitle == '装车' && this.loadingType) {
          this._appointTurnLoading();
        }
        // 手动卸车
        if (this.dialogTitle == '卸车' && this.unloadType) {
          this._getUnloadList();
        }
        // 转船 卸车
        if (this.dialogTitle == '卸车' && !this.unloadType) {
          this._refutePageList();
        }
        // 过驳
        if (this.dialogTitle == '过驳') {
          this._refutePageList();
        }
      },
      // 装车车辆 —— 重置
      carResetBtn() {
        this.condition.batchNumber = '';
        this.condition.waybillNo = '';
        this.condition.frameNumber = '';
        this.condition.brand = '';
      },
      // 展开行时是否查询 装车车辆 二级
      async judgeFn(row) {
        if (this.teamData.table[row.index].children.length <= 0) {
          // this.carSearchChildBtn(row);
          let obj = {
            type: 1,
            departurePlaceId: this.teamData.place,
            departurePortId: this.teamData.port,
            supplierId: this.teamData.supplier,
            batchNumber: row.batch_number,
            waybillNo: row.waybill_no,
          };
          const res = await loadingChildPageList(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.teamData.table[row.index].children = res.data;
        }
        return Promise.resolve;
      },
      // 装车车辆 —— 批次号 展开行
      expandChange(row, val) {
        const isExpend = val.some(r => r.index === row.index);
        if (isExpend && val.length > 0) {
          this.teamData.table[row.index].loading = true;
          Promise.all([this.judgeFn(row)]).then(() => {
            if (this.selectData.length > 0) {
              let flg = false;
              this.selectData.forEach(item => {
                if (item.id == row.batch_number + row.waybill_no) {
                  if (item.list.length > 0) {
                    item.list.forEach(tem => {
                      this.$nextTick(() => {
                        // this.$refs['children'+this.page+'-'+row.index].toggleRowSelection(
                        this.$refs[row.batch_number + row.waybill_no].toggleRowSelection(
                          this.teamData.table[row.index].children.find(tem1 => {
                            return tem.id == tem1.id;
                          }),
                          true,
                        );
                      });
                    });
                  }
                  return (flg = true);
                }
              });
              if (!flg) {
                this.selectData.push({
                  id: row.batch_number + row.waybill_no,
                  list: [],
                });
              }
            } else {
              this.selectData.push({
                id: row.batch_number + row.waybill_no,
                list: [],
              });
            }
            this.teamData.table[row.index].loading = false;
          });
        }
      },
      // 装车车辆 —— 批次号 多选框
      handleCurrentChange(val, tableId) {
        if (val.length > 0) {
          this.selectData.filter(item => {
            if (item.id == val[0].batch_number + val[0].waybill_no) {
              item.list = val;
            }
          });
        } else {
          this.selectData.filter(item => {
            if (item.id == tableId) {
              item.list = val;
            }
          });
        }
        console.log(this.selectData);
      },

      // 装车/转船/卸车 —— 确认
      saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (this.planType == 0 && this.dialogTitle == '装车' && !this.loadingType) {
              this.teamData.selection = [];
              this.selectData.forEach(item => {
                this.teamData.selection = this.teamData.selection.concat(item.list);
              });
            }
            if (this.teamData.selection.length === 0) {
              return this.$message.warning('请至少选择一个委托车！');
            }
            this.imgIsUpload = true;
            let { id, loadDate, selection, shippers, entrust, transship } = this.teamData;
            let obj = {},
              res;
            // 正常作业  装车
            if (this.dialogTitle == '装车' && !this.loadingType) {
              obj = {
                id: id,
                actualDate: loadDate,
                carList: selection.map(item => {
                  return {
                    id: item.id,
                  };
                }),
              };
              res = await batchLoading(obj);
            }
            // 转船 装车
            if (this.dialogTitle == '装车' && this.loadingType) {
              obj = {
                id: id,
                actualDate: loadDate,
                carList: selection.map(item => {
                  return {
                    id: item.id,
                  };
                }),
              };
              res = await batchTurnLoading(obj);
            }
            // 过驳
            if (this.dialogTitle == '过驳') {
              obj = {
                id: id,
                actualDate: loadDate,
                carList: selection.map(item => {
                  return {
                    id: item.id,
                  };
                }),
              };
              res = await batchTurnRefuteLoading(obj);
            }
            // 转船 卸车
            if (this.dialogTitle == '卸车' && !this.unloadType) {
              obj = {
                id: id,
                actualDate: loadDate,
                carList: selection.map(item => {
                  return {
                    id: item.id,
                  };
                }),
              };
              res = await batchTurnDischarge(obj);
            }
            // 手动卸车
            if (this.dialogTitle == '卸车' && this.unloadType) {
              obj = {
                taskType2: transship,
                taskDate: loadDate,
                taskPortId: shippers.id,
                taskToolId: entrust.id,
                carList:
                  selection.length > 0
                    ? selection.map(item => {
                        return { id: item.id };
                      })
                    : [],
              };
              res = await dockInfoShipScanUnloading(obj);
            }
            this.imgIsUpload = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            if (this.$refs.table1) this.$refs.table1.clearSelection();
            if (this.$refs.table2) this.$refs.table2.clearSelection();
            if (this.$refs.table3) this.$refs.table3.clearSelection();
            this.selectData = [];
            this.teamData.selection = [];
            this.dialogVisible = false;
            await this._dockInfoCvWaterPageList();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.carResetBtn();
        this.dialogVisible = false;
        this.selectData = [];
        this.teamData.selection = [];
        this.condition.page = 1;
        this.condition.total = 0;
        if (this.$refs.table1) this.$refs.table1.clearSelection();
        if (this.$refs.table2) this.$refs.table2.clearSelection();
        if (this.$refs.table3) this.$refs.table3.clearSelection();
      },

      // 过驳分页查询
      async _refutePageList() {
        this.shippingId = this.teamData.id;
        let obj = {
          batchNumber: this.condition.batchNumber,
          waybillNo: this.condition.waybillNo,
          deployPortId: this.teamData.id,
          taskType2: this.teamData.type,
          page: this.condition.page,
          rows: this.condition.size,
        };
        this.loadingWorkVehicles = true;
        let res = await refutePageList(obj);
        this.loadingWorkVehicles = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table = res.data.records;
        this.condition.total = res.data.total;
      },
      // 转船 装车 分页查询
      async _appointTurnLoading() {
        let obj = {
          batchNumber: this.condition.batchNumber,
          waybillNo: this.condition.waybillNo,
          deployPortId: this.teamData.id,
          taskType1: 2,
          page: this.condition.page,
          rows: this.condition.size,
        };
        let res = await appointTurnLoading(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table = res.data.records;
        this.condition.total = res.data.total;
      },
      // 手动卸车 分页查询
      async _getUnloadList() {
        let obj = {
          personnelId: this.teamData.entrust.id,
          batchNumber: this.condition.batchNumber,
          waybillNo: this.condition.waybillNo,
          frameNumber: this.condition.frameNumber,
          page: this.condition.page,
          rows: this.condition.size,
        };
        let res = await pagePortTaskList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table = res.data.records;
        this.condition.total = res.data.total;
      },
      // 过驳完成
      async refuteFinish(row) {
        let id = '';
        if (this.planType == 0) {
          id = row.exchangeDeployId;
        } else {
          id = row.id;
        }
        this.$confirm('当前数据是否过驳完成？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await refuteFinish(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._dockInfoCvWaterPageList();
          })
          .catch(() => {});
      },

      // 卸车船舶改变
      async shipChange() {
        this.$refs.ruleForm.clearValidate();
        this.teamData.table = [];
        this._getUnloadList();
      },
      // 卸车 —— 选择
      handleSelectionChange(val) {
        this.teamData.selection = val;
      },
      // 委托车 选择
      allotDataSelectionChange(val) {
        this.allotDataSelection = val.filter(row => !this.allotDataSelection.includes(row)); // 过滤掉已经存在于allotDataSelection数组中的行
      },
      //详情选择
      handleSelectionChangeCar(val) {
        this.selectionCar = val;
      },
      // 判断输入字符个数
      judgeLen(val, key) {
        if (val == '' || !val) return false;
        let len = val.split(',').length;
        if (len > 100) {
          if (key == 'batchNumber') this.condition.batchNumber = '';
          if (key == 'waybillNo') this.condition.waybillNo = '';
          if (key == 'frameNumber') this.condition.frameNumber = '';
          return this.$message.warning('查询条件不能超过100个！');
        }
      },
      importBeforeUpload(file) {
        this.importDis = true;
        if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
          this.importData.mFile = file.name;
        } else {
          this.importDis = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      importUploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        let that = this;
        this.$axios({
          method: 'post',
          url: content.action + '&id=' + that.shippingId,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.importDis = false;
            if (res.data.status !== 0) return that.$message.error(res.data.message);
            that.$message.success(res.data.message);
            this.teamData.selection = [];
            if (res.data.data) {
              res.data.data.forEach(res => {
                this.teamData.selection.push({ id: res });
              });
            }
            this.dynamicSelected();
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
            }
            this.importDis = false;
          });
      },
      /**
       * 核对对账单 导入 成功函数
       * @param res 上传成功回调
       */
      importPlanOnSuccess(res) {
        this.uploadDis = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        // this._transportPlanCvPageList()
        // this.TableDatas = res.data;
        this.$forceUpdate();
      },
      async dynamicSelected() {
        let obj = {
          batchNumber: this.condition.batchNumber,
          waybillNo: this.condition.waybillNo,
          deployPortId: this.teamData.id,
          taskType2: this.teamData.type,
          page: this.condition.page,
          rows: 99999,
        };
        this.loadingWorkVehicles = true;
        let res = await refutePageList(obj);
        this.loadingWorkVehicles = false;
        if (this.teamData.selection && res.data.records) {
          this.teamData.selection.forEach(selectionRes => {
            res.data.records.forEach(tableRes => {
              if (selectionRes.id === tableRes.id) {
                this.$refs.table2.toggleRowSelection(tableRes, true);
              }
            });
          });
        }
        this.teamData.table = res.data.records.length > 10 ? res.data.records.splice(0, 10) : res.data.records;
      },
      searchCopyFormat(value) {
        debugger;
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        this.carList.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
      },
    },
    watch: {
      selectData: {
        handler(newVal) {
          let temp = [];
          this.selectData.forEach(item => {
            temp = temp.concat(item.list);
          });
          this.carLength = temp.length;
        },
        deep: true, //深度监听
      },
      teamData: {
        handler(newVal) {
          this.carLength = this.teamData.selection.length;
        },
        deep: true, //深度监听
      },
    },
  };

  export class allotRef {}
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 245px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }

    .nav {
      width: 100%;
      //height:40px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 5px;
        margin-right: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainerNav {
        font-size: 16px;
        text-decoration: none;
        text-align: right;

        span {
          color: #3388ff;
          text-decoration: underline;
          margin-right: 10px;
          cursor: pointer;
        }

        .upload-demo {
          display: inline-block;
        }
      }

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 70vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 20px 10px;

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input__inner {
          border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px 10px 10px;
      max-height: 70vh;
      overflow: auto;

      .imgUp {
        display: flex;
        flex-direction: column;
        margin: 10px 0;

        .imgLength {
          display: flex;
          align-items: center;
          width: 100%;

          span {
            margin-left: auto;
            color: rgb(183, 183, 183);
            font-size: 16px;
          }
        }
      }

      .transport {
        width: 100%;
        position: relative;
        padding: 0 10px;
        margin-bottom: 20px;

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      .productTable {
        margin-top: 15px;

        &Nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          &Left {
            display: flex;
            align-items: center;

            ::v-deep {
              .el-input--mini .el-input__inner {
                height: 22px;
              }

              .el-input__icon {
                height: 120%;
              }
            }

            span {
              color: #606266;
              font-weight: 700;
            }
          }

          &Right {
            text-decoration: underline;
            color: rgb(51, 136, 255);
          }
        }

        ::v-deep {
          .el-checkbox {
            margin-left: 8px;
          }

          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td,
          .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      .update {
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-checkbox {
          margin-left: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td,
        .el-table th {
          padding: 0;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
      }
    }
    ::v-deep {
      .el-dialog {
        width: 55%;
      }
      .el-dialog__body {
        padding: 25px !important;
      }
    }
    .mainContainer .navContainer[data-v-6e4fe498] {
      margin-right: 20px;
    }
    .paginationContainer {
      overflow-y: hidden;
    }
    .el-table::before {
      height: 0px;
    }
  }

  .mainContainer .detail .baseInfoContentItem {
    margin-bottom: 10px;
  }

  .navContainer p {
    display: inline-block;
    width: 90px;
    text-align: right;
  }

  .nav .navBtn {
    margin-left: 7px;
  }

  .paginationContainer {
    margin-right: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
</style>
